/**
 * 優惠券「使用開始時間」是否還沒到（尚未可用）。
 * use_start_time 為 null / undefined / 無法解析時一律視為「已可用」（不誤擋）。
 *
 * 後端 app-api 在 preview / submit 會用 COUPON_NOT_IN_VALID_PERIOD 擋未開始的券；
 * 前端用這個判斷在選券前就排除/標示，避免「選了才被後端打回」。
 */
export const isBeforeUseStart = (useStartTime?: string | null, now: Date = new Date()): boolean => {
  if (!useStartTime) return false;
  const start = new Date(useStartTime);
  if (Number.isNaN(start.getTime())) return false;
  return start.getTime() > now.getTime();
};

/**
 * 到期顯示文字。
 * expiry 為空字串時代表「不限使用期限」（後端 expire_time_stamp / use_end_time 皆為 null）→ 顯示「無使用期限」，
 * 否則顯示「{MM/DD} 到期」。
 *
 * 注意：mapping 端必須在 expire_time_stamp 為 null 時給空字串，
 * 不可直接 formatDate(null)——那會被解析成 epoch（1970-01-01）而顯示成「01/01 到期」。
 */
export const couponExpiryLabel = (expiry?: string | null): string =>
  expiry ? `${expiry} 到期` : "無使用期限";
